<div>
  <input type="file" class="hidden-file-input" accept="image/png, image/jpeg" onclick="this.value = null"
    (change)="onFileSelected($event)" #fileUpload required>
  <h1>Add Author</h1>
  <br>
  <form [formGroup]="authorForm">
    <label class="fixed-size" for="first-name">First Name: </label>
    <input id="first-name" type="text" formControlName="firstName">
    <br>
    <label class="fixed-size" for="last-name">Last Name: </label>
    <input id="last-name" type="text" formControlName="lastName">
    <br>
    <div *ngIf="selectedFile != undefined; else noFile">
      <label class="fixed-size" for="author-image">Author Image: </label>
      <label>{{fileName}}</label><button class="remove-button" (click)="removeFile()">x</button>
    </div>
    <ng-template #noFile>
      <label class="fixed-size" for="author-image">Author Image: </label>
      <button class="add-button" (click)="fileUpload.click()">Add Image</button>
    </ng-template>
    <br>
    <label for="bio">Bio: </label><br>
    <textarea class="text-area-90" style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="10" cols="40"
      formControlName="bio"></textarea>
    <br>
  </form>
  <form [formGroup]="authorForm" (ngSubmit)="onSubmit()"></form>
  <button class="cancel-button" type="cancel" (click)="this.cancelClicked()">Cancel</button>
  <button class="primary-button" type="submit" [disabled]="!authorForm.valid" (click)="this.onSubmit()">Submit</button>
</div>